import AuthenticatedResource from 'resources/public/AuthenticatedResource'

export default class RewardInstanceDownloadResource extends AuthenticatedResource {
  static urlRoot = 'organizations/:organization_id/reward_instances/download' as const;

  pk() {
    return 'download';
  }
}
